export default __webpack_public_path__ + "static/chroma-s-c07c88e8a81cbb29a9153c8b52ec124f.mp4";